<template>
  <main id="main" class="d-flex flex-column align-items-center row-gap-4">
    <header class="header_page shadow_box slideInDown">
        <p id="title_header_page" class="bold">جزئیات پارچه امتحان</p>
        <img id="arrow_back_page" src="@/assets/imgs/back.svg" alt="" @click="$router.go(-1)">
    </header>

    <div class="w-95 bg-white rounded-5 d-flex flex-column row-gap-3 shadow p-3">
        <section class="bg_box_light_theme p-3 d-flex flex-column row-gap-3 shadow rounded-5 fadeIn">
            <h2 class="font_larger bold">سوال اول</h2>
            <div class="d-flex align-items-center gap-3">
                <input type="radio">
                <label class="font_small bold">الف ) جواب 1 </label>
            </div>
            <div class="d-flex align-items-center gap-3">
                <input type="radio">
                <label class="font_small bold">ب ) جواب 1 </label>
            </div>
            <div class="d-flex align-items-center gap-3">
                <input type="radio">
                <label class="font_small bold">ج ) جواب 1 </label>
            </div>
            <div class="d-flex align-items-center gap-3">
                <input type="radio">
                <label class="font_small bold">د ) جواب 1 </label>
            </div>
        </section>
    </div>
  </main>
</template>

<script>
export default {
  name: 'ReportDetail'
}
</script>

<style scoped>
</style>